import { MainLayoutComponent } from '../../components/main-layout/main-layout.component'
import { Routes, UrlSegment, UrlMatcher } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { BusinessesComponent } from './businesses.component'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { UpdateBusinessComponent } from './update-business/update-business.component'
import { CreateBusinessComponent } from './create-business/create-business.component'

// Matcher for numeric IDs
export const idMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  if (segments.length === 1 && /^\d+$/.test(segments[0].path)) {
    return { consumed: segments, posParams: { id: segments[0] } }
  }
  return null
}

// Matcher for string status
export const statusMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  const validStatuses = ['active', 'archived']
  if (segments.length === 1 && validStatuses.includes(segments[0].path)) {
    return { consumed: segments, posParams: { status: segments[0] } }
  }
  return null
}

export const businessesRoutes: Routes = [
  {
    path: 'licenses',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'BUSINESS_LIST',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', redirectTo: 'active', pathMatch: 'full' },
      { path: 'create', component: CreateBusinessComponent },
      {
        path: 'active',
        component: BusinessesComponent,
      },
      {
        path: 'archived',
        component: BusinessesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'BUSINESS_ACTION_ARCHIVE',
            redirectTo: '/licenses',
          },
        },
      },
      { matcher: idMatcher, redirectTo: ':id/general' },
      { path: ':id/:tab', component: UpdateBusinessComponent },
    ],
  },
]
